import { render } from "./UpdateCabinType.vue?vue&type=template&id=32c8250b"
import script from "./UpdateCabinType.vue?vue&type=script&lang=js"
export * from "./UpdateCabinType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__